import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { PromoOverviewMainKpiComponent } from './overview-main-kpi/promo-overview-main-kpi.component';
import { PromoOverviewProductsComponent } from './overview-products/overview-products.component';
import { PromoOverviewLoyaltyComponent } from './overview-loyalty/overview-loyalty.component';
import { PromoOverviewLoyalty11Component } from './overview-loyalty-1-1/overview-loyalty-1-1.component';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';

@Component({
  selector: 'app-promo-overview',
  templateUrl: './promo-overview.component.html',
  styleUrls: ['./promo-overview.component.css']
})
// Pagina 47 - Pagina 48 - Pagina 49 - Pagina 50
export class PromoOverviewComponent implements OnInit {
  Multi: any;
  @ViewChild(PromoOverviewMainKpiComponent) promoKpi: PromoOverviewMainKpiComponent;
  @ViewChild(PromoOverviewProductsComponent) promoOverview: PromoOverviewProductsComponent;
  @ViewChild(PromoOverviewLoyaltyComponent) promoLoyalty: PromoOverviewLoyaltyComponent;
  @ViewChild(PromoOverviewLoyalty11Component) promoLoyalty1: PromoOverviewLoyalty11Component;
  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
  oldData: any;

  items: MenuItem[];
  activeIndex: number;
  translations: any = {};

  constructor(private translate: TranslateService,
              private svcAnalytics: AnalyticsService,
              private searchModelFactory: SearchToolbarModelFactoryService) {

    this.translate.get([
      'promo.overview'
    ]).subscribe((t) => {
      this.translations = {
        page_title: t['promo.overview']
      };
    });
  }

  ngOnInit() {
    this.activeIndex = 0;

    this.items = [];

    this.translate.get([
      'promo.mainKpi',
      'promo.products',
      'promo.loyalty',
      'promo.loyalty-1-1'
    ]).subscribe(t => {
      const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
      searchParams.svcAnalytics = this.svcAnalytics;
      searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
      searchParams.finestra = SearchToolbarFilterWindow.FortySeven;
      searchParams.raggruppamento = SearchToolbarFilterGrouping.None;
      searchParams.disabledSections = [SearchToolbarSection.CardModes];

      this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
        this.searchModel = model;
      });
      this.items.push(
        {
          label: t['promo.mainKpi'],
          disabled: false,
          command: (event: any) => {
            this.activeIndex = 0;
          },

        },
        {
          label: t['promo.products'],
          command: (event: any) => {
            this.activeIndex = 1;
          }
        },
        {
          label: t['promo.loyalty'],
          command: (event: any) => {
            this.activeIndex = 2;
          }
        },
        {
          label: t['promo.loyalty-1-1'],
          command: (event: any) => {
            this.activeIndex = 3;
          }
        }
      );

      for (let index in this.items) {
        if (!this.items[index].disabled) {
          this.activeIndex = +index;
          break;
        }
      }
    });
  }

  ApplyResult (data) {
    const isDataEquals = JSON.stringify(this.oldData) === JSON.stringify(data);

    switch (this.activeIndex) {
      case 0:
        if (!isDataEquals) {
          this.promoOverview.resetData();
          this.promoLoyalty.resetData();
          this.promoLoyalty1.resetData();
        }
        this.promoKpi.searchValue(data);
        break;
      case 1:
        if (!isDataEquals) {
          this.promoKpi.resetData();
          this.promoLoyalty.resetData();
          this.promoLoyalty1.resetData();
        }

        this.promoOverview.searchValue(data);
        break;
      case 2:
        if (!isDataEquals) {
          this.promoKpi.resetData();
          this.promoOverview.resetData();
          this.promoLoyalty1.resetData();
        }

        this.promoLoyalty.searchValue(data);
        break;
      case 3:
        if (!isDataEquals) {
          this.promoKpi.resetData();
          this.promoOverview.resetData();
          this.promoLoyalty.resetData();
        }

        this.promoLoyalty1.searchValue(data);
        break;
    }

    this.oldData = { ...data };
  }


}



// WEBPACK FOOTER //
// ./src/app/views/analytics/promo/overview/promo-overview.component.ts